export enum TransactionEventFilterEnum{
    ALARM = "ALARM",
    GEOFENCE  = "GEOFENCE",
    FAILED_SELFCHECK = "FAILED_SELFCHECK",
    BATTERY = "BATTERY",
    POSITION = "POSITION",
    DEVICE_STATE = "DEVICE_STATE",
    TECHNICAL = "TECHNICAL",
    PASSING = "PASSING",
    PERIODIC = "PERIODIC"
}